import React, {useEffect, useRef, useState} from 'react';
import {Switch, useLocation} from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import {setMenuSearch, setTitleHeader} from '~/redux/ui/slice';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';

type LoadingBarRef = {
  add(value: number): void;
  decrease(value: number): void;
  continuousStart(startingValue?: number, refreshRate?: number): void;
  staticStart(startingValue: number): void;
  complete(): void;
};

export const CustomSwitch = ({children}: any) => {
  const ref = useRef<LoadingBarRef>(null);
  const dispatch: AppDispatch = useDispatch();
  const [prevLoc, setPrevLoc] = useState('');
  const location = useLocation();

  useEffect(() => {
    dispatch(setTitleHeader({title: undefined}));
    setPrevLoc(location.pathname);
    ref?.current?.continuousStart();
    if (location.pathname === prevLoc) {
      setPrevLoc('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    ref?.current?.complete();
    dispatch(setMenuSearch({q: ''}));
  }, [dispatch, prevLoc]);

  return (
    <>
      <LoadingBar color="yellow" ref={ref} />
      <Switch>{children}</Switch>
    </>
  );
};
